export default __webpack_public_path__ + "static/media/Andrea Carollo.3d7d505c.jpg";